import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Basic SEO helper: updates document.title + a meta description per route.
const TITLES = {
  "/": "PakNet — پاکستان کا اردو فورم",
  "/login": "لاگ اِن — PakNet",
  "/register": "اکاؤنٹ بنائیں — PakNet",
  "/messages": "نجی پیغامات — PakNet",
  "/settings": "ترتیبات — PakNet",
  "/admin": "Admin — PakNet",
  "/search": "تلاش — PakNet",
  "/forgot-password": "پاس ورڈ ری سیٹ — PakNet",
};

function setMeta(name, value) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setOG(prop, value) {
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export default function RouteMeta() {
  const loc = useLocation();
  useEffect(() => {
    const p = loc.pathname;
    let title = TITLES[p];
    if (!title) {
      if (p.startsWith("/t/")) title = "موضوع — PakNet";
      else if (p.startsWith("/f/")) title = "فورم — PakNet";
      else if (p.startsWith("/u/")) title = `${p.split("/")[2]} — PakNet`;
      else title = "PakNet — پاکستان کا اردو فورم";
    }
    document.title = title;
    setMeta("description", "PakNet پاکستان کا نیا اردو ڈسکشن فورم — گفتگو، سیکھنا، دوستی");
    setOG("og:title", title);
    setOG("og:type", "website");
    setOG("og:site_name", "PakNet");
  }, [loc.pathname]);
  return null;
}
